import { render, staticRenderFns } from "./AssortmentAnalysisList.vue?vue&type=template&id=16381e8b&"
import script from "./AssortmentAnalysisList.vue?vue&type=script&lang=js&"
export * from "./AssortmentAnalysisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports